export const DinamicTitle = (newTitle) => {
  return (document.title = newTitle);
};
